import { hotRanking } from '@/mocks/home';

interface HotRankingProps {
  onEnter: (message: string) => void;
}

export default function HotRanking({ onEnter }: HotRankingProps) {
  return (
    <section id="hot" className="scroll-mt-20 border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">今日热榜</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
              标题优先，点开就是直达；配图只做点缀，不耽误你吃瓜的速度。
            </p>
          </div>
          <span className="shrink-0 self-start rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600 md:self-auto">
            每 30 分钟刷新
          </span>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotRanking.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onEnter(`已打开热榜「${item.title}」（演示）`)}
              className="group flex w-full cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 text-left transition hover:border-primary-300 hover:bg-primary-50/50"
            >
              <span
                className={`w-7 shrink-0 text-center font-heading text-2xl ${
                  item.rank <= 3 ? 'text-primary-500' : 'text-foreground-300'
                }`}
              >
                {item.rank}
              </span>

              <span className="h-14 w-14 shrink-0 overflow-hidden rounded-md border border-background-200 md:h-16 md:w-16">
                <img
                  src={item.image}
                  alt={`热榜配图 ${item.rank}`}
                  title="黑料入口 热榜 配图"
                  className="h-full w-full object-cover object-top"
                />
              </span>

              <span className="flex min-w-0 flex-1 flex-col">
                <span className="truncate text-sm text-foreground-950 md:text-base">{item.title}</span>
                <span className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                    {item.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    热度 {item.heat}
                  </span>
                </span>
              </span>

              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-200 text-foreground-400 transition group-hover:border-primary-300 group-hover:text-primary-600">
                <i className="ri-arrow-right-line"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}